import { Component, OnInit } from '@angular/core';
import { CommonConstants } from './../common/utilities/commonConstants';
import { CookieHandlerService } from './../common/services/cookieHandler.service';
import { HomeService } from './home.service';
import { RouteContextProvider } from './../common/services/routeContextProvider.service';
import { RouteHandlerService } from './../common/services/routeHandler.service';
import { SharedService } from './../common/services/sharedService';
import { ActivitiHandlerService } from './../common/services/activitiHandler.service';
import { Formatter } from './../common/services/formatter';
import { EmitterService } from './../common/services/emitter.service';
import { SessionHandlerService } from '../common/services/sessionHandler.service';
import { ConfigService } from './../common/services/config.service';
import { adobe_analytics_service } from '../common/services/adobe_analytics_service';
import { HttpClientModule } from '@angular/common/http';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-home',
  template: '',
  styleUrls: ['./home.style.scss'],
  providers: [HomeService, HttpClientModule]
})
export class HomeComponent implements OnInit {
  private _UTMDataObject: any;
  public RedirectionRequired: Boolean = true;
  public ApplicationDetails: any;
  public OfferApplicationDetails: any;
  public bflJourney: boolean;
  constructor(
    private _homeService: HomeService,
    private _routeContextProvider: RouteContextProvider,
    private _cookieHandler: CookieHandlerService,
    private _sharedService: SharedService,
    private _routerService: RouteHandlerService,
    private _formatter: Formatter,
    private _activitiHandler: ActivitiHandlerService,
    private _sessionHandlerService: SessionHandlerService,
    private _emitterService: EmitterService,
    private _adobe_analytics_service: adobe_analytics_service
  ) { }
  public ngOnInit(): void {
    this.setMobileValues();
    const InsProductType = this._routeContextProvider.GetQueryParams(CommonConstants.QueryParamsKeys.InsuranceProductType);
    this._sharedService.setData(CommonConstants.QueryParamsKeys.InsuranceProductType,
      InsProductType);
    this._sessionHandlerService.DeleteSession([CommonConstants.CookieKeys.InsProductType]);
    if (InsProductType) {
      this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.InsProductType, InsProductType);
    }
    // offer specific code
    if (this._routeContextProvider.GetQueryParams(CommonConstants.QueryParamsKeys.ApplicantId)) {
      this.utmSourceStamping();
      this.CreateRequestForOffer();
      this.CreateApplicationRequest(this.OfferApplicationDetails, (response) => {
        console.log('RESPONSE==', response);
      });
    } else {
      // this.authenticateSystem();
      if (InsProductType !== '') {
        this._routerService.RouteToNextTask('revampVehicleDetailsx');
      }
    }
  }
  public initateAuthentication(cb?) {
    this.setMobileValues();
    let InsProductType = this._routeContextProvider.GetQueryParams(CommonConstants.QueryParamsKeys.InsuranceProductType);
    if (!InsProductType) {
      let url: any = window.location.pathname;
      url = url.split('/');
      // InsProductType = url.includes('car-insurance') ? 'FWGI' : url.includes('two-wheeler-insurance')
      //   ? 'TWGI' : url.includes('taxi-car-insurance-calculator') ? 'TXGI' :
      //     url.includes('commercial-vehicle-insurance-calculator') ? 'CVGI' : 'FWGI';
      InsProductType = url.includes('car-insurance') ? 'FWGI' : '';
      this._sharedService.setData(CommonConstants.QueryParamsKeys.InsuranceProductType,
        InsProductType);
      this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.InsProductType, InsProductType);
    }
    this._sessionHandlerService.DeleteSession([CommonConstants.CookieKeys.InsProductType]);
    if (InsProductType) {
      this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.InsProductType, InsProductType);
    }
    this.utmSourceStamping();
    this.authenticateSystem(cb);
  }
  public startActivitiWithApplicationCreate(
    onSuccessCallback: Function,
    applicationDetails?: any) {
    const startActivitiRequest: any = {
      activitiName: 'startFlow',
      payload: this.ApplicationDetails
    };
    console.log(startActivitiRequest);
    this.startActiviti(startActivitiRequest, onSuccessCallback);
  }
  public CreateApplicationRequest(applicationRequest: any, cb?: Function) {
    this._emitterService.changeMessage(true);
    this.ApplicationDetails = applicationRequest;
    this.initProcess((responseDataObj) => {
      this._activitiHandler.MarkTaskAsCompleted(null, 'Manual', true)
        .subscribe((resp: any) => {
          const mtResponse = resp;
          let Url = null;
          this._emitterService.changeMessage(false);
          if (!mtResponse.errorBean) {
            const InsProductType = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.InsProductType);
            if (InsProductType === 'TWGI') {
              Url = ConfigService.getInstance().getConfigObject().APIURL.MotorTwoWheelerProductLaunch;
            } else {
              Url = ConfigService.getInstance().getConfigObject().APIURL.MotorFourWheelerProductLaunch;
            }
            if (mtResponse.nextTaskKey === 'revampVehicleDetails') {
              window.location.href = Url + 'vehicleDetails';
            } else if (mtResponse.nextTaskKey === 'revampPlanDetails') {
              window.location.href = Url + 'planDetail';
            } else if (mtResponse.nextTaskKey === 'revampRenewalDetails') {
              window.location.href = Url + 'renewApplication';
            } else {
              this._routerService.RouteToNextTask(mtResponse.nextTaskKey);
            }
          } else {
            this._emitterService.changeMessage(false);
            console.log('Error Occured on ', mtResponse.errorBean);
            cb(mtResponse);
          }
        },
          (error) => {
            console.log(error);
            cb(() => { error });
          });
    });
  }
  public authenticateSystem(cb?): void {
    const productCode = CommonConstants.LOAN_PRODUCT_CODES.Motor_Insurance;
    // this.setSecretKeyForClientId(userClientId);
    this.setSystemAuthToken(productCode, cb);
  }
  private CreateRequestForOffer() {
    this.OfferApplicationDetails = {
      'insuranceProductType': this._routeContextProvider.GetQueryParams(CommonConstants.QueryParamsKeys.InsProductType),
      'insuranceApplications': {
        'insProduct': CommonConstants.LOAN_PRODUCT_CODES.Motor_Insurance
      },
      'applicantId': this._routeContextProvider.GetQueryParams(CommonConstants.QueryParamsKeys.ApplicantId),//resp.payload.applicantId,
      'applicationId': this._routeContextProvider.GetQueryParams(CommonConstants.QueryParamsKeys.ApplicationId),//resp.payload.applicationId,
      'applicationApplicantId': this._routeContextProvider.GetQueryParams(CommonConstants.QueryParamsKeys.ApplicationApplicantId), //resp.payload.applicationApplicantId,
      'policyExpired': 'N',
      'resumeJourney': false,
      'registrationNumber': this._routeContextProvider.GetQueryParams(CommonConstants.QueryParamsKeys.VehicleRegistrationNumber) !== "null" ?
        this._routeContextProvider.GetQueryParams(CommonConstants.QueryParamsKeys.VehicleRegistrationNumber) : null
    };
    this._sharedService.setData(CommonConstants.QueryParamsKeys.ApplicantId,
      this._routeContextProvider.GetQueryParams
        (CommonConstants.QueryParamsKeys.ApplicantId));
    this._sharedService.setData(CommonConstants.QueryParamsKeys.ApplicationId,
      this._routeContextProvider.GetQueryParams
        (CommonConstants.QueryParamsKeys.ApplicationId));
    this._sharedService.setData(CommonConstants.QueryParamsKeys.ApplicationApplicantId,
      this._routeContextProvider.GetQueryParams
        (CommonConstants.QueryParamsKeys.ApplicationApplicantId));
    this.storeDetailsToCookies();
  }
  // this checks if user should be ab tested or not?
  private initProcess(callback: Function) {
    this.startActivitiWithApplicationCreate(
      (mtResponse: ActivitiModel.MTResponse<any>) => {
        callback(mtResponse);
      });
  }
  private startActiviti(request: any, onSuccessCallback: Function) {
    this._activitiHandler.StartActiviti(request, true)
      .subscribe((response: ActivitiModel.MTResponse<any>) => {
        console.log('Raw Activiti working now');
        const data = response;
        if (!data.errorBean) {
          this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.ProcessInstanceDetails,
            data.payload.processInstanceDetails);
          onSuccessCallback(data);
        }
      },
        (Error) => {
          console.log(Error);
    });
  }
  private setSystemAuthToken(productCode: string, cb?): void {
    const epToken = this._cookieHandler.GetCookie(CommonConstants.CookieKeys.JWTokenEP);
    const sourceType = this._routeContextProvider.GetQueryParams('sourceType');
    let useEpToken: boolean;
    this.bflJourney = environment['bflenvironment'];
    if (this.bflJourney) {
      if (epToken && sourceType == "empPortal") {
        useEpToken = true;
      } else {
        useEpToken = false;
      }
    } else {
      if (epToken) {
        useEpToken = true;
      } else {
        useEpToken = false;
      }
    }
    if (useEpToken) {
      this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.JWToken, epToken);
      this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.GuardKey, this._cookieHandler.GetCookie(CommonConstants.CookieKeys.GuardKeyEP));
      this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.GuardToken, this._formatter
        .ConvertGuradKeyToGuardToken(this._cookieHandler.GetCookie(CommonConstants.CookieKeys.GuardTokenEP)));
      if (cb) { cb(); }
    } else {
      this._homeService.GetSystemAuthToken({
        productCode
      }).subscribe((responseData: ActivitiModel.MTResponse<any>) => {
        if (!responseData.errorBean) {
          const tokenObj = responseData.payload.tokens[0];
          const moAccessToken = this._cookieHandler.GetCookie(CommonConstants.CookieKeys.accessToken);
          // const moAccessToken = '202510291625161761735316554zodv0egVYsDF7RAGOJgnNSxTLKWN1e';
          console.log("accessToken new", moAccessToken);
          if (moAccessToken) {
          this._homeService.miniOrangeAccessToken(moAccessToken, tokenObj.token).subscribe({
            next: (res: any) => {
              console.log("accessToken res", res);
              const miniOrangeAccessToken = res?.customerAuthToken;
              this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.JWToken, miniOrangeAccessToken);
              this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.miniOrangeToken, true);
              this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.mobile_number, res?.mobileNumber);
            },
            error: (err) => {
              this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.miniOrangeToken, false);
            }
          });
          } else {
            const epToken = this._cookieHandler.GetCookie(CommonConstants.CookieKeys.JWTokenEP);
            this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.JWToken, tokenObj.token);
              this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.miniOrangeToken, false);
          }
          if (this._routeContextProvider.GetQueryParams(CommonConstants.QueryParamsKeys.IsMobile) === '1') {
            const psuedoVerifiedToken = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.PSVToken);
            this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.JWToken, psuedoVerifiedToken);
          } else {
            const psuedoVerifiedToken = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.JWToken);
            this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.JWToken, psuedoVerifiedToken);
          }
          this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.GuardKey, tokenObj.guardKey);
          this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.GuardToken, this._formatter
            .ConvertGuradKeyToGuardToken(tokenObj.guardKey));
          if (cb) { cb(); }
        } else {
          this._adobe_analytics_service.triggerAPIFailureService(responseData, 'logins/ui');
        }
      });
    }
  }
  private storeDetailsToCookies() {
    const appId = this._sharedService.getData(CommonConstants.QueryParamsKeys.ApplicationId);
    if (appId) {
      this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.LoanApplicationId, appId);
      this._cookieHandler.SetCookie(CommonConstants.CookieKeys.LoanApplicationId, appId, appId);
    }
    this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.LoanApplicationKey,
      this._sharedService.getData(CommonConstants.QueryParamsKeys.ApplicationApplicantId));
  }
  private setMobileValues() {
    this._emitterService.Get(CommonConstants.EmitterEventTypes.MobileAppCheck)
      .emit(this._routeContextProvider.GetQueryParams
        (CommonConstants.QueryParamsKeys.IsMobile));
    // Set Mobile cookie
    let mobileState = this._routeContextProvider.GetQueryParams(CommonConstants.QueryParamsKeys.IsMobile) === '1' || this._sessionHandlerService.GetSession('source') === 'mobileApp' ? '1': '0';
    this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.MobileState,mobileState);
  }
  utmSourceStamping() {
    const src_90 = this._routeContextProvider.GetQueryParams('src_90');
    const src_60 = this._routeContextProvider.GetQueryParams('src_60');
    const src_30 = this._routeContextProvider.GetQueryParams('src_30');
    const pid = this._routeContextProvider.GetQueryParams('pid');
    const source = this._routeContextProvider.GetQueryParams('utm_source');
    const medium = this._routeContextProvider.GetQueryParams('utm_medium');
    const campaign = this._routeContextProvider.GetQueryParams('utm_campaign');
    const content = this._routeContextProvider.GetQueryParams('utm_content');
    const term = this._routeContextProvider.GetQueryParams('utm_term');
    const utmType = src_90 ? 'src_90' : src_60 ? 'src_60' : src_30 ? 'src_30' : pid ? 'pid' : 'utm';
    let utm = '';
    if ((source || medium || campaign || content || term) && utmType === 'utm') {
      utm = ['', source, medium, campaign, content, term].join(':');
    }
    this._sessionHandlerService.SetSession('UTM', src_90 || src_60 || src_30 || pid || utm);
    this._sessionHandlerService.SetSession('UtmType', utmType);
  }
}
